import { memo } from "react";
import { styled } from "@mui/material/styles";
import Switch, { type SwitchProps } from "@mui/material/Switch";

const StyledSwitch = styled(Switch)(({ theme }) => {
  const neutral500 = theme?.palette?.neutral?.[500] || "var(--neutral-500)";

  return {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
    "@media (max-width: 576px)": {
      width: 44,
      height: 24,
    },
    "& .MuiSwitch-switchBase": {
      padding: 1,
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: theme.palette.common.white,
        "& + .MuiSwitch-track": {
          backgroundColor: (theme.vars || theme).palette.success.main,
          opacity: 1,
          border: "none",
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: (theme.vars || theme).palette.success.main,
      },
      "&.Mui-disabled": {
        "& + .MuiSwitch-track": {
          opacity: 0.5,
          backgroundColor:
            "color-mix(in srgb, var(--palette-common-black) 12%, transparent)",
        },
        "& .MuiSwitch-thumb": {
          backgroundColor: neutral500,
        },
      },
      "@media (max-width: 576px)": {
        "&.Mui-checked": {
          transform: "translateX(20px)",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: 24,
      height: 24,
      backgroundColor: "var(--neutral-white)",
      boxShadow: "none",
      border: "1px solid var(--neutral-200)",
      "@media (max-width: 576px)": {
        width: 22,
        height: 22,
      },
    },
    "& .MuiSwitch-track": {
      borderRadius: "var(--radius-round)",
      border: `1px solid ${neutral500}`,
      backgroundColor: neutral500,
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"]),
    },
  };
});

type CustomSwitchProps = SwitchProps & {
  checked: boolean;
  onChange: NonNullable<SwitchProps["onChange"]>;
};

const CustomSwitch = ({
  checked,
  onChange,
  disabled,
  className,
  ...props
}: CustomSwitchProps) => {
  return (
    <StyledSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={className}
      disableRipple
      {...props}
    />
  );
};

export default memo(CustomSwitch);
